export enum BookPageLayoutMode {
    Default = 0,
    Column1 = 1,
    Column2 = 2,
}